/**
 * @typedef {import("@prismicio/client").Content.BlogSlice} BlogSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<BlogSlice>} BlogProps
 * @param {BlogProps}
 */

import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";


const PromotedCard = ({ article, i }) => {

  return <div className={`mb-12 md:mb-0 border-2 rounded-b-[30px] rounded-tl-[92px] border-dark-grey bg-green lg:bg-white lg:col-span-2 lg:rounded-b-[0px] lg:rounded-r-[30px]`}>
    <PrismicLink field={article} className={`h-full lg:flex`}>
      <div className={`h-full lg:basis-1/2`}>
        <PrismicImage
          field={article.data.preview_picture}
          className={`rounded-tl-[90px] border-b-2 border-dark-grey w-full  object-cover h-[200px] lg:h-full lg:border-b-0 lg:border-r-2`}  loading={i <3 ? '' : 'lazy'}/>
      </div>
      <div className={`px-30px py-6 md:pt-30px md:pb-10 md:basis-1/2`}>
        <div className="bg-dark-pink w-fit px-4 border-2 border-dark-grey rounded-full mb-4">
          <p className="filtre-text font-semibold">{article.data.preview_tag}</p>
        </div>
        <PrismicRichText
          field={article.data.preview_title}
          components={{ heading3: ({ children }) => <h3 className="mb-2.5">{children}</h3> }} />
        <PrismicRichText
          field={article.data.preview_text}
          components={{ paragraph: ({ children }) => <p className={`line-clamp-4 lg:line-clamp-[9] md:mb-30px`}>{children}</p> }} />
        <div className={`text-center hidden md:inline-block`}>
          <div
            className="button button-rounded button-text overflow-hidden background-slide-white">
            Lire la suite
          </div>
        </div>
      </div>
    </PrismicLink>
  </div>
}

const Card = ({ article, i }) => {
  return <div className={`mb-12 md:mb-0 border-2 rounded-b-[30px] rounded-tl-[92px] border-dark-grey bg-white`}>
    <PrismicLink field={article} className={`h-full`}>
      <PrismicImage
        field={article.data.preview_picture}
        className={`rounded-tl-[90px] border-b-2 border-dark-grey w-full  object-cover h-[200px]`}  loading={i <3 ? '' : 'lazy'}/>

      <div className={`px-30px py-6 md:pt-30px md:pb-10`}>
        <div className="bg-dark-pink w-fit px-4 border-2 border-dark-grey rounded-full mb-4">
          <p className="filtre-text font-semibold">{article.data.preview_tag}</p>
        </div>
        <PrismicRichText
          field={article.data.preview_title}
          components={{ heading3: ({ children }) => <h3 className="mb-2.5">{children}</h3> }} />
        <PrismicRichText
          field={article.data.preview_text}
          components={{ paragraph: ({ children }) => <p className={`line-clamp-4`}>{children}</p> }} />
        <div className={`text-center hidden`}>
          <div
            className="button button-rounded button-text overflow-hidden background-slide-white">
            Lire la suite
          </div>
        </div>
      </div>
    </PrismicLink>
  </div>
}

const Blog = ({ slice, index, context }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`bg-grain bg-white pt-[87px] pb-16 md:pt-20 md:pb-28 ${index !== 0 ? 'border-t-2 border-dark-grey' : ''}`}
    >
      <div className="max-w-[1400px] m-auto px-4 md:px-7 lg:px-10 ">
        <div className="mb-5 md:mb-[70px]">
          <div className="fil-text mb-3 md:mb-12">
            <Breadcrumbs context={context} index={index} />
          </div>
          <div className="mr-4 mb-4 md:max-w-[800px] md:mx-auto md:text-center">
            <PrismicRichText field={slice.primary.title} />
          </div>
          <div className="md:max-w-[500px] md:mx-auto md:text-center">
            <PrismicRichText field={slice.primary.text} />
          </div>
        </div>
        <div className="hidden flex-wrap gap-10 md:gap-[60px] justify-center blog-filter mb-5 md:mb-[70px]">
          <p><a> Guide </a></p>
          <p><a> Article </a></p>
          <p><a> Vidéo </a></p>
          <p><a> Outil </a></p>
        </div>


        <div className="md:flex md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-x-4 md:gap-y-10 lg:gap-[71px] mb-12 md:mb-14">
          {slice.primary.articles.map(({ article, is_promoted }, i) => {
            return is_promoted ? <PromotedCard article={article} key={i} i={i} /> : <Card article={article} key={i} i={i}/>
          }
          )}
        </div>
        <div className="text-center hidden">
          <div className="button button-rounded button-text overflow-hidden background-slide-white">
            <a href="">
              Voir plus</a>
          </div>
        </div>
      </div >
    </section >
  );
};

export default Blog;
